
import React from 'react'
import StatusContext from '../../../contexts/StatusContext'
import AITestContext from '../../../contexts/AITestContext'
import { DisplaySubtopics } from "../aitest/DisplaySubtopics"
import { AlertDialog } from '../alertdialog/AlertDialog'
import { ConfirmDialog } from '../alertdialog/ConfirmDialog'
import { ProgressIcon } from '../customicons/ProgressIcon';
import { useState } from "react";
import { CustomTooltip } from '../customtooltip/CustomTooltip'
import { PushButton } from '../pushbutton/PushButton'
import Checkbox from '@mui/material/Checkbox';


import "./aitest.css"

export const Subtopics = () => {

  const [openDialog, handleDisplay] = useState(false);
  const [openConfirmDialog, handleConfirmDisplay] = useState(false);
  const [dialogtext, setDialogText] = useState('');


  let {
    isLoading,
    changeLanguage,
    changeTestLanguage,
  } = React.useContext(StatusContext);

  let {
    topic,
    subtopics,
    generateSubtopics,
    createcollegetestmode,
    setShowCorrectAnswersOnly,
    showcorrectanswersonly,

    setShowQuestionsOnly,
    showquestionsonly,
    testisbought,

    getTestScore,
    getTestCount
   
  } = React.useContext(AITestContext);

  const onShowQuestionsOnly = () => {
   
    const b = false
 
    const a = [...subtopics]
    a.forEach((item)=> 
      {
        item.promptsandresponses.forEach((subitem) => {
        subitem.response.answer[0][1] = b
        subitem.response.answer[0][2] = b
        subitem.response.answer[1][1] = b
        subitem.response.answer[1][2] = b
        subitem.response.answer[2][1] = b
        subitem.response.answer[2][2] = b
        })
      })
    setShowCorrectAnswersOnly(false)
    setShowQuestionsOnly(!showquestionsonly)
  }

   const onShowAnswersOnly = () => {

    let b = !showcorrectanswersonly
 
    let a = [...subtopics]
    a.forEach((item)=> 
      {
        item.promptsandresponses.forEach((subitem) => {
        subitem.response.answer[0][1] = b
        subitem.response.answer[0][2] = b
        subitem.response.answer[1][1] = b
        subitem.response.answer[1][2] = b
        subitem.response.answer[2][1] = b
        subitem.response.answer[2][2] = b
        })
      })

    //setPromptsAndResponses(a)

    setShowQuestionsOnly(false)
    setShowCorrectAnswersOnly(b)
      
  }

  const closeDialogBox = () => {
    handleDisplay(false);
  };

  const openDialogBox = () => {
    handleDisplay(true);
  };

  const alertYesBuy = () => {
    closeDialogBox()
    generateSubtopics()
  }

  const alertCancelBuy = () => {
    closeDialogBox()
  }

  const closeConfirmDialogBox = () => {
    handleConfirmDisplay(false);
  };

  const openConfirmDialogBox = () => {
    handleConfirmDisplay(true);
  }

  const confirmYes = () => {
    closeConfirmDialogBox()
  }

  const onClickSubtopics = () => {

    if (topic) {
      if (subtopics.length) {
        setDialogText(changeLanguage('aitest', 'newsubtopics'))
        openDialogBox()
      }
      else
        generateSubtopics()

    }
    else {
      setDialogText(changeLanguage('aitest', 'text24'))
      openConfirmDialogBox()
    }

  }

  return (

    <div style={{ width: '100%' }}>
      {
      createcollegetestmode && 
        <div>
          <CustomTooltip title={changeLanguage('aitest', 'subtopicssubtext')}>
            <span>
            <PushButton onClick={onClickSubtopics} label={changeLanguage('aitest', 'generatesubtopics')} disablebutton={isLoading || !topic || topic === ''} />
            </span>
          </CustomTooltip>
        </div>
      }

      {
        (subtopics.length) ?
        <>
        {/* add checkboxes}*/}
      {
        testisbought &&
        <>
         <br/>
            <div className = 'flex-container' style={{marginTop: '-10px'}}>
              <Checkbox className='checkBoxTestName' onClick = {onShowAnswersOnly}
                checked={showcorrectanswersonly}
                sx={{ '& .MuiSvgIcon-root': { fontSize: 24, color: 'maroon', border: 'none'},       
              }} />          
              <label style={{paddingRight:'5px'}}> {changeTestLanguage('aitest', 'showanswersonly')} </label>
            </div>
                  
            <div className = 'flex-container' style={{marginTop: '-10px'}}>
              <Checkbox className='checkBoxTestName' onClick = {onShowQuestionsOnly}
                checked={showquestionsonly}
                sx={{ '& .MuiSvgIcon-root': { fontSize: 24, color: 'maroon', border: 'none'},       
              }} />          
              <label style={{paddingRight:'5px'}}> {changeTestLanguage('aitest', 'showquestionsonly')} </label>
            </div>
          </>               
        }

       
          <div className="mainButtons">
            <label style={{ fontSize: '16px', fontWeight: 'bold' }}>{changeTestLanguage("aitest", 'questions')} :   <span style={{ color: 'maroon' }}>
              {getTestScore()} / {getTestCount()}
            </span></label>
          </div>
          
        
         
          <div className="subtopicsContainer">
            {
              Array.isArray(subtopics) &&
              subtopics.map((subtopic) => (
                  <DisplaySubtopics key={subtopic.id} text={subtopic} />
              ))
            }
          </div>
           </>
          :
          null
       
      }

      <br></br>
      <AlertDialog alertYes={alertYesBuy} alertCancel={alertCancelBuy} openDialog={openDialog} closeDialog={closeDialogBox} prompt={dialogtext} />
      <ConfirmDialog alertYes={confirmYes} openDialog={openConfirmDialog} closeDialog={closeConfirmDialogBox} prompt={dialogtext} />
      <ProgressIcon isLoading={isLoading} />

    </div>

  )
}




